import React from 'react';
import { useHistory } from 'react-router-dom';
import { alertTriangle } from 'assets';
import { NHSLoginErrorPageContent } from 'services/content';
import styles from './styles.module.css';

const NHSLoginRedirect = () => {
  const history = useHistory();

  return (
    <div className={`coop-l-container`}>
      <div className={`${styles.container}`}>
        <img className={styles.icon} src={alertTriangle} alt={'Alert'} />
        <h2 className={styles.header}>{NHSLoginErrorPageContent.headingText}</h2>
        <p className={styles.bodyText}>{NHSLoginErrorPageContent.bodyText}</p>
        <button
          className={`coop-btn coop-btn--secondary ${styles.button}`}
          onClick={() => history.push('/pharmacy/register')}>
          {NHSLoginErrorPageContent.ctaText}
        </button>
      </div>
    </div>
  );
};

export default NHSLoginRedirect;
